import { MIDDLE_STYLE } from '@constants/responsive';
import { Button, ButtonProps, Tooltip } from 'antd';

const SquareIconButton = ({
  icon,
  title,
  buttonProps,
}: {
  icon: React.ReactNode;
  title: string;
  buttonProps?: ButtonProps;
}) => {
  return (
    <Tooltip title={title}>
      <Button
        {...buttonProps}
        style={{ borderRadius: '5px', aspectRatio: '1/1', padding: 0, ...MIDDLE_STYLE }}>
        {icon}
      </Button>
    </Tooltip>
  );
};

export default SquareIconButton;
